export class Wizard {
    init() {
        let wizards = document.querySelectorAll('form.aib--wizard-form');
        this.updated = [];

        wizards.forEach((form, i) => {
            window.livewire.hook('message.processed', () => {
                this.updated[i] = $(form).find('input[name!=next_step]').serialize();
                this.manageSelects(form);
            });

            this.manageSelects(form);

            this.updated[i] = $(form).find('input[name!=next_step]').serialize();

            document.querySelectorAll('a:not(#confirmWizardChangeTabModal-leave)').forEach((link) => {
                link.addEventListener('click', (e) => {
                    let step = e.currentTarget.dataset.step;
                    let submitButton = form.querySelector('button[type="submit"]');
                    let url = e.currentTarget.getAttribute('href');

                    // Allow command+click, ctrl+click, or links with target="_blank"
                    if (e.metaKey || e.ctrlKey || e.currentTarget.target === "_blank") {
                        return;
                    }

                    if (submitButton && url && (url.substring(0, 4) === 'http' || url.substring(0, 1) === '/')) {
                        e.preventDefault();
                        this.manageSelects(form);

                        if (this.updated[i] !== $(form).find('input[name!=next_step]').serialize()) {
                            let input;

                            if (step) {
                                if (form.querySelector('input[name="next_step"]')) {
                                    input = form.querySelector('input[name="next_step"]');
                                    input.setAttribute('value', step);
                                } else {
                                    input = document.createElement("input");
                                    input.setAttribute('type', 'hidden');
                                    input.setAttribute('name', 'next_step');
                                    input.setAttribute('value', step);
                                    form.appendChild(input);
                                }
                            } else {
                                if (form.querySelector('input[name="_aib_force_redirect_url"]')) {
                                    input = form.querySelector('input[name="_aib_force_redirect_url"]');
                                    input.setAttribute('value', url);
                                } else {
                                    input = document.createElement("input");
                                    input.setAttribute('type', 'hidden');
                                    input.setAttribute('name', '_aib_force_redirect_url');
                                    input.setAttribute('value', url);
                                    form.appendChild(input);
                                }
                            }

                            document.querySelector('#confirmWizardChangeTabModal-leave').setAttribute('href', url);
                            $('#confirmWizardChangeTabModal').modal("show");

                            document.querySelector('#confirmWizardChangeTabModal-save').addEventListener('click', (event) => {
                                event.preventDefault();
                                submitButton.click();
                            });

                            return;
                        }

                        window.location.href = url;
                    }
                });
            });
        });
    }

    manageSelects(form) {
        form.querySelectorAll('select[data-plugin="selectpicker"]').forEach((select) => {
            let input;
            let name = '_fk_aib_' + select.name;
            let value = '';

            form.querySelectorAll('select[data-plugin="selectpicker"][name="' + select.name + '"]').forEach((s) => {
                value = value + '_' + s.value;
            });

            if (form.querySelector('input[name="' + name + '"]')) {
                input = form.querySelector('input[name="' + name + '"]');
                input.setAttribute('value', value);
            } else {
                input = document.createElement("input");
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', name);
                input.setAttribute('value', value);
                form.appendChild(input);
            }
        });
    }
}